import React, { useState, useEffect } from "react"
import { Button } from "react-bootstrap"
import _ from "lodash"

import { getValidFilters } from "../utils"
import { isLTPM } from "../../../components/shared_components_registration"
import RunFiltersEditor from "../../../components/widgets/RunFiltersEditor"

const universalDefaultFilters = [
  {
    category: "Run Parameters",
    valueString: "No",
    tag: "placeholder",
    isDropdown: true,
  },
]

const registration = {
  default_filters: isLTPM
    ? [
        {
          category: "Run Parameters",
          valueString: "All",
          tag: "active",
          isDropdown: true,
        },
        ...universalDefaultFilters,
      ]
    : [
        {
          category: "Run Parameters",
          valueString: "All",
          tag: "site",
          isDropdown: true,
        },
        ...universalDefaultFilters,
        {
          category: "Run Parameters",
          valueString: "All",
          tag: "reactor",
          isDropdown: true,
        },
        {
          category: "Run Parameters",
          valueString: "Not Required",
          tag: "event_labels",
          isDropdown: true,
        },
        {
          category: "Run Parameters",
          valueString: "Not Required",
          tag: "skynaught_event_labels",
          isDropdown: true,
        },
      ],
  placeholder_text: (intl, isRunView) =>
    isLTPM
      ? intl.formatMessage({
          id: "archiveddash.keyword.search",
        })
      : isRunView
        ? "Match Site, Reactor, Run ID, or Run Details"
        : "Match site, Sample ID, or Run ID",
  search_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.search" }) : "Search"),
  apply_filter_message: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "general.apply.filter.message",
          defaultMessage: "Click search button to apply new or changed filters",
        })
      : "Click search button to apply new or changed filters",
}

export default function FiltersEditor({
  onSearch,
  intl,
  isRunView = false,
  disabled = false,
  includeActiveFilter = false,
  expProjectChange,
}) {
  const [filters, setFilters] = useState([])
  const [prevFilters, setPrevFilters] = useState([])
  const [searchString, setSearchString] = useState("")
  const [updatingSearch, setUpdatingSearch] = useState(false)

  const getFilters = (filter_arr) => {
    const finalFilters = [...getValidFilters(filter_arr)]

    if (searchString && searchString.length > 0) {
      finalFilters.push({
        tag: "keyword",
        value: searchString,
      })
    }
    return finalFilters
  }

  useEffect(() => {
    let default_filters = registration.default_filters
    if (includeActiveFilter) {
      default_filters = [
        ...default_filters.filter((f) => f.tag !== "active"),
        {
          category: "Run Parameters",
          valueString: "Yes",
          tag: "active",
          isDropdown: true,
        },
      ]
    }
    setPrevFilters(default_filters)
    setFilters(default_filters)

    const initialSearch = /[?&]search=([^&]+)/.exec(window.location.search)
    const initialKeywords = initialSearch && decodeURI(initialSearch[1]) ? decodeURI(initialSearch[1]) : ""
    if (initialKeywords !== "") {
      setSearchString(initialKeywords)
    }

    if (initialKeywords) {
      onSearch &&
        onSearch([...getFilters(default_filters), { tag: "keyword", value: decodeURI(initialSearch[1]) }])
    } else {
      onSearch && onSearch(getFilters(default_filters))
    }
  }, [])

  useEffect(() => {
    !_.isEqual(filters, prevFilters) ? setUpdatingSearch(true) : setUpdatingSearch(false)
  }, [filters])

  const doFilterUpdate = (ev) => {
    ev.stopPropagation()
    ev.preventDefault()
    setPrevFilters(filters)
    setUpdatingSearch(false)
    onSearch && onSearch(getFilters(filters))
  }

  return (
    <form onSubmit={(ev) => doFilterUpdate(ev)}>
      <div className={"row"} style={{ marginBottom: "3px" }}>
        <div className={"col-sm-8"}>
          <input
            id={"run-search"}
            className={"form-control"}
            type={"text"}
            value={searchString}
            disabled={disabled}
            onChange={(e) => setSearchString(e.target.value)}
            placeholder={registration.placeholder_text(intl, isRunView)}
          />
        </div>
        <div className={"col-sm-2"}>
          <Button variant={"primary"} disabled={disabled} type={"submit"}>
            {registration.search_label(intl)}
          </Button>
        </div>
      </div>
      {updatingSearch && (
        <div className={"row"}>
          <div className={"col-sm-12"}>
            <span className={"warning-message"}>{registration.apply_filter_message(intl)}</span>
          </div>
        </div>
      )}
      <div className={"row"}>
        <div className={"col-sm-12"}>
          {isRunView && (
            <RunFiltersEditor
              filters={filters}
              prevFilters={prevFilters}
              updateFilters={(transitionFn) => {
                const newFilters = transitionFn(filters)
                if (newFilters !== null) {
                  setFilters(newFilters)
                }
              }}
              expProjectChange={expProjectChange} // LTPM concept - passing for useEffect trigger of reload
              disabled={disabled}
              intl={intl}
            />
          )}
        </div>
      </div>
    </form>
  )
}
